import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { ToolBarMenu } from '@maced/angular-components/lib/navigation-drawer/toolbar/toolbar.model';
import { delay, first, of } from 'rxjs';

@Component({
  selector: 'app-navigation-drawer',
  templateUrl: './navigation-drawer.component.html'
})
export class NavigationDrawerComponent {
  isShowMenubar = false;
  isShowCascadebar = false;
  isShowToolbar = true;
  breadCrumbLimit: number = 20;
  public breadcrumbsName: any[] = [];

  toolbarMenuList: ToolBarMenu[] = [
    { id: 'Toolbar', name: 'Cursor', tooltip: 'Cursor', icon: 'icon-cursor', isDivider: true, disable: true, badge: 102 },
    { id: 'Selection', name: 'Selection', tooltip: 'Selection', icon: 'icon-selection' },
    { id: 'Pen', name: 'Pen', tooltip: 'Pen', toolmsg:'(mouse-only functionality)', icon: 'icon-pencil' },
    { id: 'Highlighter', name: 'Highlighter', tooltip: 'Highlighter', toolmsg:'(mouse-only functionality)', icon: 'icon-pencil-line' },
    { id: 'Text', name: 'Text', tooltip: 'Text', toolmsg:'(mouse-only functionality)', icon: 'icon-type' },
    { id: 'Mask', name: 'Mask', tooltip: 'Mask', icon: 'icon-mask', isDivider: true },
    { id: 'Save Progress', name: 'Save Progress', tooltip: 'Save Progress', icon: 'icon-save', isDivider: true },
    { id: 'Delete Selected', name: 'Delete Selected', tooltip: 'Delete Selected', icon: 'icon-trash' }
  ];
  menuList = [
    { id: 'Table Of Contents', name: 'Table Of Contents', icon: 'icon-bookshelf', trailingIcon: 'icon-chevron-right' },
    { id: 'Quick Links', name: 'Quick Links', icon: 'icon-cursor-click', trailingIcon: 'icon-chevron-right', disabled: true },
    { id: 'My Bookmarks', name: 'My Bookmarks', icon: 'icon-bookmark', trailingIcon: 'icon-chevron-right' },
    { id: 'My Notes', name: 'My Notes', icon: 'icon-notes', trailingIcon: 'icon-chevron-right' },
    { id: 'Extra Activities', name: 'Extra Activities', icon: 'icon-file-plus', trailingIcon: 'icon-chevron-right' },
    { id: 'All Activities', name: 'All Activities', icon: 'icon-file-plus', trailingIcon: 'icon-chevron-right' },
    { id: 'My Downloads', name: 'My Downloads', icon: 'icon-download', trailingIcon: 'icon-chevron-right' },
    { id: 'Read Aloud', name: 'Read Aloud', icon: 'icon-volume-max', trailingIcon: 'icon-chevron-right' }
  ];

  cascadeMenus: any[] = [];
  cascadeMenuList = [
    [
      { id: 'Student Book', name: 'Student Book', icon: 'icon-chevron-right', leadingIcon: 'icon-notes', isContainSubMenu: true },
      { id: 'Share eBook', name: 'Share eBook', icon: 'icon-chevron-right', leadingIcon: 'icon-notes', isContainSubMenu: true, disabled: true },
      { id: 'DigitalWorkbook', name: 'Digital Workbook', icon: 'icon-notes', badge: 100, leadingIcon: 'icon-chevron-right' }
    ],
    [
      { id: 'Part 1', name: 'Part 1', isTitle: true },
      { id: 'Contents', name: 'Contents', icon: 'icon-chevron-right', leadingIcon: 'icon-notes', isContainSubMenu: true },
      { id: 'WelcomeUnit', name: 'Welcome Unit', badge: 99 },
      { id: 'Part 2', name: 'Part 2', isTitle: true },
      { id: 'Unit 1 at School', name: 'Unit 1 at School', leadingIcon: 'icon-notes', icon: 'icon-chevron-right', isContainSubMenu: true },
      { id: 'Unit 2 Family & Friends', name: 'Unit 2 Family & Friends', leadingIcon: 'icon-notes', trailingIcon: 'icon-chevron-right', icon: 'icon-chevron-right', isContainSubMenu: true }
    ],
    [
      { id: 'Lesson 1 Vocabulary', name: 'Lesson 1 Vocabulary' }
    ]
  ];
  isLinksClickable: boolean = false;
  nextIconClass: string = 'icon-chevron-slash';
  numberOfLinksVisible = 3;
  breadcrumbsContainer: string = 'breadcrumbsContainer';
  toolbarHamburgerAriaLabel: string = 'Menu';
  hasMoreMenuButton=true;
  hasMultipleOptionClass=true;
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateUIAsPerWindow();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: any) {
    let value: any
    if( document.getElementsByClassName('c-menu__list-item-link active').length !==0 ){
      value = document.getElementsByClassName('c-menu__list-item-link active');
    } else{
      value = document.getElementsByClassName('c-menu__list-item-link');
    }

    if(!this.isShowCascadebar){ 
      this.onCloseMenubar();
    }

    if (value) {
      let minvalue = (this.cascadeMenus.length > 1 )? 2 : this.cascadeMenus.length
      if (value.length > 2) {
        value[value.length - minvalue].focus();
      } else if(value.length === 2 && this.cascadeMenus.length !== value.length){
        value[value.length - 1].focus();
      } else {
        value[0].focus();
      }
      this.onClickCascadeBack(value.length);
    }   
  }
  constructor( @Inject(PLATFORM_ID) public platformId: Object) {
    if(isPlatformBrowser(platformId)){
      this.updateUIAsPerWindow();
    }
  }

  updateUIAsPerWindow() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 1023) {
      this.isShowMenubar = true;
      this.isShowToolbar = false;
    } else {
      this.isShowMenubar = false;
      this.isShowToolbar = true;
    }
  }

  onClickHamburger() {
    this.isShowCascadebar = false;
    this.isShowMenubar = !this.isShowMenubar;

    if (this.isShowMenubar) {
      this.toolbarHamburgerAriaLabel = 'Menu';
    } else {
      this.toolbarHamburgerAriaLabel = 'Menu'
    }

    this.toolbarMenuList.forEach((obj: any) => obj.active = false);
    if (!this.isShowMenubar) {
      this.menuList.forEach((obj: any) => obj.active = false);
    }
  }

  onClickToolMenu(menu: any) {
    this.toolbarMenuList.forEach((obj: any) => obj.active = false);
    this.toolbarMenuList.forEach((obj: any) => {
      if (obj.id === menu.id) {
        obj.active = true;
      }
      return obj;
    });
  }

  onCloseMenubar() {
    of('Observable To Update HTML').pipe(first(), delay(100)).subscribe(() => {
      this.isShowMenubar = false;
      this.menuList.forEach((obj: any) => obj.active = false);
      if (this.isShowMenubar) {
        this.toolbarHamburgerAriaLabel = 'Menu';
      } else {
        this.toolbarHamburgerAriaLabel = 'Menu';
        let menuBarButton: any = document.getElementsByClassName('c-navigation-tools__burger-button');
        if (menuBarButton.length > 0) {
          menuBarButton[0]?.focus();
        }
      }
    });
  }

  onClickMenu(menu: any) {
    this.cascadeMenus = [];
    this.breadcrumbsName = [];
    const windowWidth = window.innerWidth;
    if(!menu.disabled){
      if (windowWidth < 1023) {
        this.isShowCascadebar = true;
      } else {
        this.isShowMenubar = false;
        this.isShowCascadebar = true;
      }
  
      this.cascadeMenus.push({
        name: menu.name,
        isVisible: true,
        menus: this.cascadeMenuList[0]
      });
  
      this.menuList.forEach((obj: any) => {
        if (obj.id === menu.id) {
          obj.active = true;
        } else {
          obj.active = false;
        }
        return obj;
      });
    }

  }

  onClickMoreMenu() {
    this.onClickCascadeClose();
  }

  onClickCascadeMenu(menu: any, index: number) {
    if(!menu.disabled){
      this.cascadeMenus.splice(index + 1, this.cascadeMenus.length - (index + 1));

      if (menu.isContainSubMenu) {
        this.displayBreadcrumbs(menu);
        this.cascadeMenus.push({
          name: menu.name,
          isVisible: true,
          menus: this.cascadeMenuList[index + 1]
        });
      }
  
      this.cascadeMenus.forEach((parentObj: any, i: number) => {
        const windowWidth = window.innerWidth;
        if (windowWidth < 1023) {
          if (i <= index && menu.isContainSubMenu) {
            parentObj.isVisible = false;
          }
        }
  
        if (i > index) {
          parentObj.menus.forEach((obj: any) => obj.active = false);
        } else if (i === index) {
          parentObj.menus.forEach((obj: any) => {
            if (obj.id === menu.id) {
              obj.active = true;
            } else {
              obj.active = false;
            }
            return obj;
          });
        }
      });
    }
  }

  onClickCascadeBack(index: number) {
    const windowWidth = window.innerWidth;
    if (windowWidth < 1023) {
      this.cascadeMenus.splice(index, 1);
      this.breadcrumbsName.splice(index - 1, 1);
      this.numberOfLinksVisible = this.breadcrumbsName.length - 1
      if (this.cascadeMenus.length > 0) {
        this.cascadeMenus[this.cascadeMenus.length - 1].isVisible = true;
      }
    } else {
      this.cascadeMenus.splice(this.cascadeMenus.length - 1, 1);
    }
    if (this.cascadeMenus.length === 0) {
      this.onClickCascadeClose();
    }
  }

  onClickCascadeClose() {
    this.isShowCascadebar = false;
    this.isShowMenubar = true;
    this.cascadeMenuList.forEach((parentObj: any) => {
      parentObj.forEach((obj: any) => obj.active = false);
    });
    of('Observable To Update HTML').pipe(first(),delay(100)).subscribe(() => {
      let menuActiveList:any = document.getElementsByClassName('c-menu__list-item-link active');
      if(menuActiveList.length > 0){
        menuActiveList[0]?.focus();
      }
    })
  }

  hasTitleBar(index: number) {
    const windowWidth = window.innerWidth;
    if (windowWidth < 1023) {
      return true;
    } else if (index > 0) {
      return false;
    } else {
      return true;
    }
  }

  hasBreadcrumbs() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 1023 && this.breadcrumbsName.length) {
      return true;
    } else {
      return false;
    }
  }

  displayBreadcrumbs(menu: any) {
    if (menu && menu.name) {
      if (this.breadcrumbsName.length) {
        let breadcrumbsData = this.breadcrumbsName.find(data => data.name === menu.name);
        if (!breadcrumbsData) {
          this.breadcrumbsName.push({
            id: menu.id,
            name: menu.name,
            label: menu.name
          })
          this.numberOfLinksVisible = this.breadcrumbsName.length - 1
        }
      } else {
        this.breadcrumbsName.push({
          id: menu.id,
          name: menu.name,
          label: menu.name
        })
        this.numberOfLinksVisible = this.breadcrumbsName.length - 1
      }
    }
  }
}